import React from 'react';
import t from 'tcomb-form';

class NumberInput extends t.form.Component {

    render () {
        let arrowDown = <div onClick={this.incrementValue.bind(this, -0.5)} className="arrow-down"></div>;
        if (this.props.options.attrs.arrowDisabled) {
            arrowDown = <div className="arrow-down gray"></div>;
        }

        let labelClasses = 'form-control form-control-number input-hourly-rate currency';

        if (DJ_CONST.LOCALE_CONF.currency === '€') {
            labelClasses += ' currency--euro';
        }

        if (this.props.options.error) {
            labelClasses += ' has-error';
        }

        return (
            <label className={labelClasses}>
                <div onClick={this.incrementValue.bind(this, 0.5)} className="arrow-up"></div>

                <input ref="rate" value={this.props.value} onChange={this.inputChange.bind(this)} type="text" />

                <span className="help-block error-block">{this.props.options.error}</span>
                {arrowDown}
            </label>
        );
    }

    getValue() {
        // Replace all commas with dots, then replace all dots after the first one and replace all NaN characters.
        let value = this.refs.rate.getDOMNode().value.toString().replace(",", ".");
        const dotIndex = value.indexOf(".");
        if (dotIndex > 0) {
            value = value.split(".", 1) + '.' + value.substring(dotIndex+1, dotIndex+2).replace(".", "");
        }
        value = value.replace('/[0-9]./g', "");
        return value;
    }

    inputChange() {
        const input = this.getValue();
        this.props.onChange(input, ['rate']);
    }

    incrementValue(n) {
        const rate = this.refs.rate.getDOMNode();
        rate.value = parseFloat(this.refs.rate.getDOMNode().value) + n >= 0 ? parseFloat(this.refs.rate.getDOMNode().value) + n : 0;
        this.props.onChange(rate.value.toString(), ['rate']);
    }
}

export default NumberInput;



/** WEBPACK FOOTER **
 ** ./app/src/components/NumberInput.js
 **/